import { Action } from '@ngrx/store';
import { CreateDraftResponse } from '@cemex-core/cmx-api/models/drafts/responses/create-draft-response';
import { Order } from '@cemex-core/cmx-api';
import { Prices } from '@ordersnproducts/modules/one-click-order/models/prices';

export enum OneClickProfileActionTypes {
  CREATE_PROFILE = '[One Click] Create order profile',
  CREATE_PROFILE_COMPLETED = '[One Click] Create order profile completed',
  UPDATE_PROFILE = '[One Click] Update order profile',
  LOAD_PROFILE_DETAIL = '[One Click] Start Load profile detail',
  LOAD_PROFILE_DETAIL_SUCCESS = '[One Click] Success Load profile detail',
  LOAD_PROFILE_DETAIL_ERROR = '[One Click] Error Load profile detail',
  RESET_BUILDER = '[One Click] Reset builder',
  RESET = '[One Click] Reset',
  LOAD_PROFILE_PRICES = '[One Click] Load profile prices',
  LOAD_PROFILE_PRICES_COMPLETE = '[One Click] Load profile prices complete',
  LOAD_PROFILE_PRICES_ERROR = '[One Click] Load profile prices error',
  SET_PROFILE_PRICES_BLOCKED = '[One Click] Set profile prices blocked',
  RESET_PRICES = '[One Click] Reset Prices',
}

export class OneClickCreateProfileAction implements Action {
  readonly type = OneClickProfileActionTypes.CREATE_PROFILE;

  constructor() {}
}

export class OneClickUpdateProfileAction implements Action {
  readonly type = OneClickProfileActionTypes.UPDATE_PROFILE;

  constructor() {}
}

export class OneClickCreateProfileCompleteAction implements Action {
  readonly type = OneClickProfileActionTypes.CREATE_PROFILE_COMPLETED;

  constructor(public payload: CreateDraftResponse) {}
}

export class OneClickProfileResetAction implements Action {
  readonly type = OneClickProfileActionTypes.RESET;

  constructor() {}
}

export class OneClickLoadOrderDetailStartAction implements Action {
  readonly type = OneClickProfileActionTypes.LOAD_PROFILE_DETAIL;

  constructor(public payload: number) {}
}

export class OneClickLoadOrderDetailSuccessAction implements Action {
  readonly type = OneClickProfileActionTypes.LOAD_PROFILE_DETAIL_SUCCESS;

  constructor(public payload: Order) {}
}

export class OneClickLoadOrderDetailErrorAction implements Action {
  readonly type = OneClickProfileActionTypes.LOAD_PROFILE_DETAIL_ERROR;

  constructor(public payload: any) {}
}

export class OneClickProfileResetBuilderAction implements Action {
  readonly type = OneClickProfileActionTypes.RESET_BUILDER;

  constructor() {}
}

export class OneClickLoadOrderPricesAction implements Action {
  readonly type = OneClickProfileActionTypes.LOAD_PROFILE_PRICES;

  constructor() {}
}
export class OneClickLoadOrderPricesCompleteAction implements Action {
  readonly type = OneClickProfileActionTypes.LOAD_PROFILE_PRICES_COMPLETE;

  constructor(public payload: Prices) {}
}

export class OneClickLoadOrderPricesErrorAction implements Action {
  readonly type = OneClickProfileActionTypes.LOAD_PROFILE_PRICES_ERROR;

  constructor(public payload: any) {}
}

export class OneClickSetProfilePricesBlocked implements Action {
  readonly type = OneClickProfileActionTypes.SET_PROFILE_PRICES_BLOCKED;

  constructor(public payload: boolean) {}
}

export class OneClickProfileResetPricesAction implements Action {
  readonly type = OneClickProfileActionTypes.RESET_PRICES;

  constructor() {}
}

export type OneClickProfileActions =
  | OneClickCreateProfileAction
  | OneClickUpdateProfileAction
  | OneClickCreateProfileCompleteAction
  | OneClickProfileResetAction
  | OneClickLoadOrderDetailStartAction
  | OneClickLoadOrderDetailSuccessAction
  | OneClickLoadOrderDetailErrorAction
  | OneClickProfileResetBuilderAction
  | OneClickLoadOrderPricesAction
  | OneClickLoadOrderPricesCompleteAction
  | OneClickLoadOrderPricesErrorAction
  | OneClickSetProfilePricesBlocked
  | OneClickProfileResetPricesAction;
